import React from 'react';
import { useState, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { 
  //BrowserRouter as Router, 
  Routes,
  Route, 
} from 'react-router-dom';

//import axios from 'axios';
import axios_api from './Api';

import Header from './components/Header';
import SideBar from './components/Sidebar';
import OrderList from './components/OrderList';
import GroupsTemplates from './components/GroupsTemplates';
import LabList from './components/LabList';
import TicketList from './components/TicketList';
import Order from './components/Order';
import TemplateView from './components/TemplateView';
import TemplateCreate from './components/TemplateCreate';
import TemplateEdit from './components/TemplateEdit';
import Lab from './components/Lab';
import Group from './components/Group';
import { OrderFormUpload, ContractUpload } from './components/UploadDocuments';
import TicketUpdate from './components/Ticket_Update';

import { API_URL, AUTH_TOKEN } from './Context';


function ScrollToTop() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    // "document.documentElement.scrollTo" is the magic for React Router Dom v6
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant", // Optional if you want to skip the scrolling animation
    });
  }, [pathname]);

  return null;
}


function ProtectedPages({setAuthToken, appUserName, setAppUserName}) {
  const [orders, setOrders] = useState([]);
  const api_url = useContext(API_URL);  
  const token = useContext(AUTH_TOKEN);

  React.useEffect(() => {

    let orders = axios_api.get(api_url + '/orders', {
      headers: {"Authorization": token},
      params: {"year": 2025}
    });

    orders.then(
      (result) => {
        let apiReturnedOrder = result.data;
        setOrders(apiReturnedOrder);
      },
      (error) => {
        console.log(error)
        setOrders([]);
      }
    );

  }, []);


  return(
    <>
      <ScrollToTop />
      <Header 
        setAuthToken={setAuthToken} 
        appUserName={appUserName} 
        setAppUserName={setAppUserName}
      /> 
      <div className="row plato">
        <div className="col-2 fixed-top vh-100 p-0 left-panel-wrapper">
          <SideBar
          />
        </div>
        <div className="col-2"></div>
        <div className="col-10 border-start px-4 pb-4 right-panel">
          <Routes>
            <Route exact path="/" element={
              <OrderList
                orders={orders} 
              />
            }/>
            <Route exact path="/templates" element={
              <GroupsTemplates/>
            }/>
            <Route exact path="/labs" element={
              <LabList/>
            }/>
            <Route exact path="/tickets" element={
              <TicketList/>
            }/>
            <Route path="/ticket/:ticketId" element={
              <TicketUpdate 
              />
            }/>              
            <Route path="/order/:orderId" element={
              <Order 
              />
            }/>
            <Route path="/order/:orderId/order_form_upload" element={
              <OrderFormUpload 
              />
            }/>
            <Route path="/order/:orderId/contract_upload" element={
              <ContractUpload
              /> 
            }/>            
            <Route path="/template/:templateId" element={
              <TemplateView 
              />
            }/>
            <Route path="/template/create" element={
              <TemplateCreate 
              />
            }/>            
            <Route path="/template/edit/:templateId" element={
              <TemplateEdit 
              />
            }/>    
            <Route path="/lab/:labId" element={
              <Lab 
              />
            }/>
            <Route path="/group/:groupId" element={
              <Group 
              />
            }/>

          </Routes>
        </div>
      </div>
    </>
  )
}

export default ProtectedPages